import { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { useFormikContext } from 'formik';

import { Deal } from '../../gql/dealGql';
import { DealType, useDealersQuery } from '../../gql/generated/graphql';

import { GridFormColumn, GridFormRow } from '../shared/GridForm';
import Select from '../shared/Select';

const DealerDropdown = () => {
  const { values, setFieldValue } = useFormikContext<Deal>();
  const { data, loading } = useDealersQuery({
    fetchPolicy: 'cache-first',
    skip: values.type !== DealType.Marketplace,
  });

  const dealerOptions = useMemo(
    () =>
      (data?.dealers ?? [])
        .filter((dealer) => dealer.id)
        .map((dealer) => ({
          label: dealer.name,
          value: String(dealer.id),
        })),
    [data?.dealers],
  );

  if (values.type !== DealType.Marketplace) {
    return null;
  }

  return (
    <GridFormColumn>
      <GridFormRow minChildWidth={270}>
        <Box gridColumn="span 1">
          <Select
            label="Dealer"
            name="selected_dealer_id"
            options={dealerOptions}
            isLoading={loading}
            isRequired
            value={values.selected_dealer_id ? String(values.selected_dealer_id) : ''}
            onChange={(event) => {
              const { value } = event.target;
              setFieldValue('selected_dealer_id', value ? Number(value) : null, true);
            }}
          />
        </Box>
      </GridFormRow>
    </GridFormColumn>
  );
};

export default DealerDropdown;
